import { Controller } from "@hotwired/stimulus"

import Swal from 'sweetalert2';

export default class extends Controller {
  static targets = ['arquivo']
  static values = {
    filename: String
  }
  atualizaNome(e) {
    this.arquivoTarget.textContent = e.target.files[0] !== undefined ? e.target.files[0].name : 'Insira aqui o arquivo'
  }

  async enviar(e) {
    e.preventDefault();

    const result = await Swal.fire({
      title: 'Atenção!',
      text: 'Tem certeza de que deseja enviar anexar o relatório e enviar para a validação da chefia? \n\nO servidor não poderá mais modificar o relatório.',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Não',
      confirmButtonText: 'Sim',
      backdrop: true,
      focusCancel: true,
      allowOutsideClick: false,
    });

    if(result.isConfirmed) {
      const form = document.getElementById('form-box-arquivo');

      if(form) {
        form.submit();
      } else {
        alert('Formulário não encontrado!')
      }
    } else {
      const submitButton = document.querySelector('input[type=submit]');
      if(submitButton) {
        submitButton.disabled = false
      }
    }
  }
}